import { render, staticRenderFns } from "./extra-category-cards.vue?vue&type=template&id=1c395eac&scoped=true&lang=pug&"
import script from "./extra-category-cards.vue?vue&type=script&lang=js&"
export * from "./extra-category-cards.vue?vue&type=script&lang=js&"
import style0 from "./extra-category-cards.vue?vue&type=style&index=0&id=1c395eac&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c395eac",
  null
  
)

export default component.exports